import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { NotifierService } from 'angular-notifier';
@Component({
  selector: 'app-delete-confirmation-modal',
  templateUrl: './delete-confirmation-modal.component.html',
  styleUrls: ['./delete-confirmation-modal.component.scss']
})
export class DeleteConfirmationModalComponent implements OnInit {
  title: string;
  message: string;
  confirm: FormGroup;
  formSumitAttempt: boolean;
  isDelete: boolean = false;
  constructor(public dialogRef: MatDialogRef<DeleteConfirmationModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmDialogModel,
    private fb: FormBuilder,
    private notifierService: NotifierService) {
    this.title = data.title;
    this.message = data.message;
    //@ts-ignore
    var $body = $(document.body);
    //@ts-ignore
    var oldWidth = $body.innerWidth();
    //@ts-ignore
    $body.css("overflow", "hidden");
    //@ts-ignore
    $body.width(oldWidth);
  }
  ngOnInit() {
    this.confirm = this.fb.group({
      reason: ''
    })
  }

  onConfirm(): void {
    if (this.message === 'Are you sure you want to close your account?') {
      this.confirm.controls["reason"].setValidators([Validators.required]);
      this.confirm.controls["reason"].updateValueAndValidity();
      this.isDelete = true;
    } else {
      this.dialogRef.close(true);
    }
  }

  deleteUser(): void {
    if (this.confirm.valid) {
      this.dialogRef.close({ reason: this.confirm.value.reason, status: true });
    } else {
      this.notifierService.notify('error', 'Invalid Inputs');
      this.formSumitAttempt = true;
    }
  }

  onDismiss(): void {
    this.dialogRef.close(false);
  }

  isFieldValid(field: string) {
    return (!this.confirm.get(field).valid && this.confirm.get(field).touched ||
      this.confirm.get(field).untouched && this.formSumitAttempt);
  }
}

export class ConfirmDialogModel {
  rebalanceDetailOfEachStock: unknown[];
  constructor(public title: string, public message: string) {
  }
}
